import React from "react";

const PageNotFound = () => (
  <div class="container">
    <div class="jumbotron text-center">404 - Page not found.</div>
  </div>
);

export default PageNotFound;
